import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../components/front/Header';
import Footer from '../components/front/Footer';
import ShortFooter from '../components/front/ShortFooter';
function DefaultLayout({ children }) {
  
  return (
    <React.Fragment>
      <div className=''>

      <Header />
      {children}
      </div>
      {/* <Footer/>  */}
      <ShortFooter/>
    </React.Fragment>
  )
}


export default withRouter(DefaultLayout);